import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SpinnerInfoBox } from 'rio-uikit';

export default class SpinnerText extends Component {

    renderContent() {
        if (this.props.showSpinner) {
            return <SpinnerInfoBox text={this.props.text} />;
        }
        return this.props.text;
    }

    render() {
        return (
            <div className={'spinner-text'}>
                {this.renderContent()}
            </div>
        );
    }
}

SpinnerText.propTypes = {
    text: PropTypes.node,
    showSpinner: PropTypes.bool,
};

SpinnerText.defaultProps = {
    text: '',
    showSpinner: false,
};
